<script>
  import { VueMaskDirective as mask } from 'v-mask'
  import ClickOut from '../../../../utils/directives/clickout'
  import OrdenarLeilao from './FiltroOrdenarLeilao'
  import Service from '../../../../domain/leiloes/services'
  import UPagination from '../../../_default/components/Uloc/Pagination'
  import { forEach as _forEach, debounce } from 'lodash'
  import {StatusTitleColor} from '../../../../domain/leiloes/helpers/LoteStatus'

  export default {
    components: {
      UPagination,
      OrdenarLeilao
    },
    nome: 'pesquisa-historico-leiloes-veiculo',
    directives: {mask, ClickOut},
    data () {
      return {
        openCFilter: false,
        isLoading: false,
        leiloes: null,
        paginationLimits: [25, 50, 100],
        pagination: {
          totalPages: 0,
          totalItems: 0,
          atualPage: 1,
          limit: 25
        },
        checkeds: 0,
        checkedAll: false,
        filtros: {
          busca: ''
        },
        prevent: {},
        isUploadingImport: false,
        activeImport: false,
        importStatus: {
          percent: 0,
          finish: false,
          mostrarErros: false,
          historico: {
            leiloes: 0,
            lotes: 0,
            erros: 0,
            logErros: []
          },
          preProcessarImportacao: false,
          processarImportacao: false,
          dadosImportacao: null
        }
      }
    },
    computed: {
      noLeiloes () {
        if (!this.leiloes) {
          return false
        }
        return !(this.leiloes || []).length
      }
    },
    mounted () {},
    methods: {
      loading (v) {
        this.isLoading = !!v
      },

      nextElement ({target}) {
        let index = parseInt(target.getAttribute('tabindex'))
        let next = index + 1
        document.querySelector('[tabindex="' + next + '"').focus()
      },
      open (leilaoId, loteId) {
        this.$router.push({name: 'lotes.visualizar', params: {leilao: leilaoId, id: loteId}})
      },

      carregaLeiloes () {
        const {busca} = this.filtros
        if (busca.length < 7) return

        this.leiloes = null
        this.isLoading = true

        Service.buscarHistoricoLeiloesLote(busca)
          .then(response => {
            this.isLoading = false
            console.log(response.data)
            this.leiloes = response.data
          })
          .catch(error => {
            this.isLoading = false
            console.log(error)
          })
      },

      /* carregaLeiloes (limit, page, filtros) {
        this.leiloes = null
        this.isLoading = true
        Service.lista(limit, page, filtros)
          .then((response) => {
            this.isLoading = false
            this.leiloes = response.data.leiloes
            this.pagination.atualPage = response.data.offset
            this.pagination.totalPages = response.data.totalPages
            this.pagination.totalItems = response.data.total
          })
          .catch((response) => {
            this.isLoading = false
            console.log(response)
          })
      }, */

      changePage (page) {
        console.log('Change page ', page)
        this.pagination.atualPage = page
        this.carregaLeiloes(this.pagination.limit, page, this.montaFiltros())
      },

      checkAll (o) {
        this.$nextTick(() => {
          let ca = this.checkedAll
          let _vm = this
          console.log(ca)
          if (ca === true) {
            console.log(ca, o.length)
            this.checkeds = o.length
          } else {
            this.checkeds = 0
          }
          _forEach(o, (item, key) => {
            _vm.$set(this.leiloes, key, Object.assign({}, this.leiloes[key], {selected: ca})) // Analisar desempenho
            // item.selected = ca
            // console.log(item)
          })
        })
      },
      lazyCheck: function (l) {
        this.$nextTick(() => {
          if (l.selected) {
            this.checkeds += 1
          } else {
            this.checkeds += -1
          }

          if (this.checkeds < this.leiloes.length) {
            this.checkedAll = false
          } else {
            this.checkedAll = true
          }
        })
      },

      montaFiltros () {
        let filtros = this.filtros
        let mount = ''
        // Busca
        if (filtros.busca.length > 0) {
          mount += '&busca=' + filtros.busca
        }
        return mount
      },

      pesquisar: debounce(function () { // debounce para evitar fazer mais de uma requisição no key event
        let busca = this.filtros.busca
        if (this.prevent.busca === busca) {
          return
        } // previne a repetição de uma chamada de api
        this.prevent.busca = busca
        this.carregaLeiloes()// this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      }, 500),
      StatusTitleColor (s, t) {
        return StatusTitleColor(s, t)
      }
    }
  }
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">

            <div class="bg-light lter b-b wrapper-md">
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <h1 class="font-thin h3">
                    Histórico de Leilões de Veículo
                  </h1>
                  <small class="text-muted">
                    Pesquise por placa ou chassi
                  </small>
                </div>
                <div class="col-sm-6 col-xs-12">
                  <div class="text-right text-left-xs">

                  </div>
                </div>
              </div>

            </div>

            <div class="panel panel-default">
              <div class="wrapper clearfix">
                <div class="col-sm-9 m-b-xs"></div>
                <div class="col-sm-3">
                  <div class="input-group">
                    <input type="text" class="input-sm form-control" v-model="filtros.busca" @keyup="pesquisar"
                           placeholder="Pesquisar">
                    <span class="input-group-btn">
                                <button class="btn btn-sm btn-default" type="button">Buscar</button>
                            </span>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-hover table-striped b-t b-light">
                  <thead>
                  <tr>
                    <th style="width:20px;">
                      <label class="i-checks m-b-none">
                        <input type="checkbox" @change="checkAll(leiloes)" v-model="checkedAll" tabindex="0"
                               aria-checked="false"
                               aria-invalid="false"><i></i>
                      </label>
                    </th>
                    <th>ID</th>
                    <th>Título do Leilão</th>
                    <th>Abertura</th>
                    <th>Nº do Lote</th>
                    <th>Título do Lote</th>
                    <th>Status do Lote</th>
                  </tr>
                  </thead>
                  <tbody>
                  <!-- FAKE -->
                  <tr v-if="isLoading" v-for="i in [1,2,3]">
                    <td class="v-middle">
                      <u-fake-loader width="20px" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <a class="text-cap custom-link ">
                        <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                      </a>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                  </tr>
                  <!-- ngRepeat: pessoa in pessoas| limitTo: 10 -->
                  <tr v-for="leilao in leiloes">
                    <td class="v-middle"><label
                      class="i-checks m-b-none"><input v-on:click.stop="lazyCheck(leilao)" type="checkbox" name="post[]"
                                                       v-model="leilao.selected"
                                                       tabindex="0" aria-checked="false"
                                                       aria-invalid="false"><i></i></label></td>
                    <td @click="open(leilao.id, leilao.loteId)" role="button" tabindex="0">{{ leilao.id }}</td>
                    <td @click="open(leilao.id, leilao.loteId)" role="button" tabindex="0">
                      <a class="text-cap custom-link ">{{ leilao.tituloLeilao }}</a>
                      <!--<div>-->
                      <!--<small class="text-muted  block text-ellipsis ">126 lotes</small>-->
                      <!--</div>-->
                    </td>
                    <td @click="open(leilao.id, leilao.loteId)" role="button" tabindex="0">
                      {{ moment(leilao.dataAbertura.date).format('DD/MM/YYYY HH:mm') }}
                    </td>
                    <td @click="open(leilao.id, leilao.loteId)" role="button" tabindex="0">
                      {{leilao.numeroLote}}
                    </td>
                    <td @click="open(leilao.id, leilao.loteId)" role="button" tabindex="0">
                      {{leilao.tituloLote}}
                    </td>
                    <td @click="open(leilao.id, leilao.loteId)" role="button" tabindex="0">
                      <span :class="'text-' + StatusTitleColor(leilao.statusLote, 'class')">{{StatusTitleColor(leilao.statusLote)}}</span>
                    </td>
                  </tr><!-- end ngRepeat: pessoa in pessoas| limitTo: 10 -->

                  <tr v-if="noLeiloes">
                    <td colspan="6">Nenhum registro encontrado</td>
                  </tr>

                  </tbody>
                </table>
              </div>
              <footer class="panel-footer">
                <div class="row">
                  <div class="col-sm-4 hidden-xs">
                    Mostrar:
                    <select @change="changePage(1)" v-model="pagination.limit"
                            class="input-sm form-control w-auto inline v-middle">
                      <option v-for="p in paginationLimits" :value="p">{{ p }}</option>
                    </select>
                    por página
                  </div>
                  <div class="col-sm-4 text-center">
                    <small class="text-muted inline m-t-sm m-b-sm ">{{ pagination.atualPage }} / {{
                      pagination.totalPages
                      }}
                    </small>
                  </div>
                  <div class="col-sm-4 text-right text-center-xs">
                    <u-pagination @changePage="changePage" :atual="pagination.atualPage"
                                  :total="pagination.totalPages"></u-pagination>
                  </div>
                </div>
              </footer>
            </div>

          </div>
        </div>
        <!-- /.col -->
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// PesquisaHistoricoLeiloesVeiculo.vue?3691c825